import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import styles from './IntegerInput.module.scss';

const IntegerInput = ({ max, min, onChange, value }) => {
  const preventDot = useCallback((event) => {
    const { key } = event;

    if (key === '.') {
      event.preventDefault();
      event.stopPropagation();
    }
  }, []);

  const handleOnChange = useCallback(
    (event) => {
      const {
        target: { value },
      } = event;

      onChange(value === '' ? '' : Number(value));
    },
    [onChange]
  );

  return <input className={styles.numberValue} max={max} min={min} onChange={handleOnChange} onKeyDown={preventDot} step='1' type='number' value={value} />;
};

IntegerInput.propTypes = {
  max: PropTypes.string.isRequired,
  min: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number.isRequired,
};

export default IntegerInput;
